import React from "react";
import { connect } from "react-redux";

import SelectTherapyArea from "./SelectTherapyArea";
import "./styles/AdminTherapyCategory.scss";
import DownArrow from "../../images/icons/down_arrow_black.svg";

@connect(store => {
  return {
    therapy_areas: store.therapy_areas,
    therapy_categories: store.therapy_categories,
    app: store.app,
    practices: store.practices
  };
})
class SelectTherapyCategories extends React.Component {
  constructor(props, store) {
    super(props);
    this.state = {
      openCategories: {},
      practices: this.props.practices,
      currentPracticeId: this.props.app.practice.id,
      currentPractice: this.props.app.practice,
      selectedPracticeType: this.props.selectedPracticeType,
      therapyCategories: this.props.therapy_categories
    };
    this.category_areas = this.category_areas.bind(this);
    this.categoryClick = this.categoryClick.bind(this);
    this.setCurrentPractice = this.setCurrentPractice.bind(this);
  }

  componentDidMount() {
    this.setCurrentPractice();
  }

  setCurrentPractice() {
    const currentPractice = this.state.practices.find(
      practice => practice.id === this.state.currentPracticeId
    );
    this.setState({ currentPractice: currentPractice });
  }

  category_areas(categoryId) {
    let { therapy_areas, checkedCond, click } = this.props;
    if (!therapy_areas) return [];

    return Object.keys(therapy_areas)
      .filter(areaId => {
        if (!therapy_areas[areaId]) return false;
        return therapy_areas[areaId].categories.indexOf(categoryId) !== -1;
      })
      .map(areaId => (
        <SelectTherapyArea
          click={() => {
            return click(therapy_areas[areaId]);
          }}
          checkedCond={checkedCond}
          area={therapy_areas[areaId]}
          key={`${categoryId}-${therapy_areas[areaId]._id}`}
        />
      ));
  }

  toggelOpen(id) {
    this.setState({
      openCategories: !this.state.openCategories[id]
    });
  }

  categoryClick(id) {
    let newState = { ...this.state.openCategories };
    newState[id] = !this.state.openCategories[id];
    this.setState({
      openCategories: newState
    });
  }

  render() {
    let { therapy_categories, children, typeSelected, app } = this.props;
    let { openCategories, currentPractice, therapyCategories } = this.state;
    return (
      <div className="">
        <div>
          {Object.values(therapyCategories)
            .filter(category => {
              if (this.props.app.title == "Admin: Videos") {
                return category.practice_type == typeSelected;
              } else {
                return category.practice_type == app.practice.practice_type;
              }
            })
            .map(cat => (
              <div onClick={() => this.categoryClick(cat._id)} key={cat._id}>
                <div className="select-category">
                  <div className="row">
                    <div className="fill">{cat.name}</div>
                    <div>
                      <img
                        src={DownArrow}
                        alt="Open"
                        className={
                          "down-arrow svg-icon " +
                          (openCategories[cat._id] && "open")
                        }
                        height="24px"
                      />
                    </div>
                  </div>
                  <ul className={!openCategories[cat._id] && "hide"}>
                    {this.category_areas(cat._id)}
                  </ul>
                </div>
              </div>
            ))}
        </div>
        {children}
      </div>
    );
  }
}

export default SelectTherapyCategories;



// WEBPACK FOOTER //
// ./src/components/admin/SelectTherapyCategories.jsx